import { render, staticRenderFns } from "./referenceMaterial.vue?vue&type=template&id=da689e94&scoped=true&"
import script from "./referenceMaterial.vue?vue&type=script&lang=js&"
export * from "./referenceMaterial.vue?vue&type=script&lang=js&"
import style0 from "./referenceMaterial.vue?vue&type=style&index=0&id=da689e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da689e94",
  null
  
)

export default component.exports